var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlightlySmilingFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1067_4113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9656 3.0127C0.49375 3.0127 0.03125 24.8439 0.03125 29.1658C0.03125 33.4877 8.95625 36.9877 19.9656 36.9877C30.9781 36.9877 39.9 33.4846 39.9 29.1658C39.9 24.8439 39.4406 3.0127 19.9656 3.0127Z",
    fill: "#FCC21B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9655 29.7121C15.5498 29.7121 13.0342 27.1683 12.928 27.0621C12.7477 26.8671 12.6509 26.6095 12.6581 26.3441C12.6653 26.0787 12.776 25.8267 12.9666 25.6418C13.1571 25.457 13.4124 25.354 13.6779 25.3549C13.9434 25.3557 14.198 25.4604 14.3873 25.6464C14.4655 25.7246 16.4436 27.6808 19.9655 27.6808C23.4873 27.6808 25.4655 25.7277 25.5498 25.6433C25.739 25.4525 25.9958 25.3442 26.2644 25.3418C26.5331 25.3395 26.7918 25.4434 26.9842 25.6308C27.0794 25.7236 27.1555 25.8341 27.208 25.9563C27.2605 26.0784 27.2884 26.2097 27.2901 26.3426C27.2919 26.4755 27.2674 26.6074 27.2181 26.7309C27.1688 26.8543 27.0957 26.9669 27.003 27.0621C26.8967 27.1683 24.3811 29.7121 19.9655 29.7121Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1251 21.2503C11.7219 21.2628 10.5719 19.9159 10.5563 18.244C10.5407 16.5659 11.6657 15.1972 13.0688 15.1847C14.4688 15.1722 15.6219 16.519 15.6376 18.1972C15.6532 19.8722 14.5282 21.2378 13.1251 21.2503ZM26.9094 21.2503C28.3094 21.2472 29.4438 19.8878 29.4407 18.2159C29.4376 16.5378 28.2969 15.1847 26.8969 15.1878C25.4938 15.1909 24.3563 16.5503 24.3594 18.2284C24.3657 19.9003 25.5063 21.2534 26.9094 21.2503Z",
    fill: "#2F2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1067_4113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlightlySmilingFace);
export default __webpack_public_path__ + "static/media/slightly-smiling-face.c18bb8ff77b91936d4b1f75e640b9380.svg";
export { ForwardRef as ReactComponent };